module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/managers/martine_schrey-c743bf71b20db418d75ef304d112ffae.jpg";